import React from "react";
import {cn} from "../utils";

// must use the "bg-background" class to get the correct background color

const ReadwiseIcon = ({className, ...props}: { className?: string } & React.SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        className={cn(className, "")}
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none">
        <g>
            <path d="M50 0H0V50H50V0Z" className={"fill-black dark:fill-white opacity-90"}/>
            <path
                d="M36.2225 35.7866C37.2767 37.5404 38.1366 38.1234 39.8953 38.3323V40.0861H31.2186L23.091 26.527H21.0603V35.4174C21.0603 37.7979 21.6481 38.1282 24.15 38.3371V40.0909H11.0525V38.3371C13.5544 38.1282 14.1423 37.793 14.1423 35.4174V15.5524C14.1423 13.1331 13.6322 12.8416 11.0525 12.6327V10.8789H24.5338C32.6615 10.8789 36.9075 12.589 36.9075 18.5985C36.9075 23.1457 34.6971 25.3173 30.2422 26.0655L36.2225 35.7866ZM22.2311 13.7161C21.5266 13.7161 21.0603 14.2164 21.0603 14.9695V23.6898H24.4221C27.9005 23.6898 29.9701 22.4364 29.9701 18.5985C29.9701 14.7168 27.9005 13.7161 24.5387 13.7161H22.2311Z"
                className={"fill-white dark:fill-black"}/>
            <path d="M31.345 11.918H18.7041V23.9856H31.345V11.918Z" className={"fill-white dark:fill-black"}/>
            <path
                d="M29.7184 14.0234C29.0334 15.2914 30.0925 21.2669 30.0925 21.2669C30.1071 21.5827 29.8933 21.8596 29.5824 21.9276C29.5824 21.9276 23.1016 21.9568 20.9543 23.7446"
                className={"fill-black dark:fill-white"}/>
        </g>
    </svg>
);

export {ReadwiseIcon};